import React from "react";

export default function Footer() {
  return (
    <footer className="relative z-10 mt-32 border-t border-[var(--rb-gold-soft)]/60">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid md:grid-cols-3 gap-8 text-sm">
        <div className="flex items-start gap-4">
          <img src="/heirloom-logo.png" alt="The Heirloom Pet" className="h-20 w-auto" />
        </div>
        <div className="md:text-center">
          <div className="tracking-celestial text-[var(--rb-text-muted)] mb-3">A Quiet Note</div>
          <p className="font-serif-display italic text-[17px] text-[var(--rb-text-heading)] leading-snug">
            &ldquo;Until we meet again at the meadow,<br/>where the sun is warm and the flowers never fade.&rdquo;
          </p>
        </div>
        <div className="md:text-right">
          <div className="tracking-celestial text-[var(--rb-text-muted)] mb-3">Contact</div>
          <a href="mailto:Theheirloompet@gmail.com" className="text-[var(--rb-text-body)] hover:text-[var(--rb-gold)] transition-colors">Theheirloompet@gmail.com</a>
          <p className="text-[var(--rb-text-muted)] mt-1">By appointment · Handcrafted dioramas</p>
          <a href="/return-policy" className="inline-block mt-3 text-[12px] tracking-[0.2em] uppercase text-[var(--rb-text-muted)] hover:text-[var(--rb-gold)] transition-colors" data-testid="footer-return-policy-link">Return &amp; Refund Policy</a>
        </div>
      </div>
      <div className="border-t border-[var(--rb-gold-soft)]/40 py-5 text-center text-[11px] tracking-[0.25em] uppercase text-[var(--rb-text-muted)]">
        The Heirloom Pet · Crafted with reverence · © {new Date().getFullYear()}
      </div>
      <div className="py-4 text-center font-serif-display italic text-[13px] text-[var(--rb-text-muted)]">
        <span className="text-[var(--rb-gold)]">✦</span>{" "}
        Built in loving memory of <a href="/memorial/e8f56ae1-princess" className="text-[var(--rb-text-heading)] hover:text-[var(--rb-gold)] transition-colors">Princess</a>, our first.{" "}
        <span className="text-[var(--rb-gold)]">✦</span>
      </div>
    </footer>
  );
}
